import(/* webpackMode: "eager" */ "/Users/connorspackman/Developer/Cylerian/website/app/events/page.js");
